{
    "registration": {
        "activation": {
            "accepted_legal_documents": "Accepted legal documents:",
            "activate": "Enable registration",
            "approve_request": "Approve request",
            "audience_type_title": "Choose your registration audience type",
            "bulk_approve_confirmation": "Are you sure you want to approve the selected requests?",
            "bulk_approved_success": "The request have been approved.|All {0} requests have been approved.",
            "bulk_denied_success": "The request have been denied.|All {0} requests have been denied.",
            "bulk_deny_confirmation": "Are you sure you want to deny the selected requests?",
            "created_pax": "Created participant: {0}",
            "deny_request": "Deny request",
            "intro": "Enable registration and build your own custom registration page",
            "landing_page_type": {
                "custom": {
                    "desc": "Create a comprehensive multi-page site using our flexible drag-and-drop editor.",
                    "title": "Custom site builder"
                },
                "multilingual_warning": "The custom site builder currently does not support multilingual registration pages.",
                "new_badge": "New",
                "standard": {
                    "desc": "Single-page fixed layout with limited design flexibility. Best for quick setups and simple registrations.",
                    "title": "Standard express site"
                },
                "title": "Choose your registration landing page type"
            },
            "messages": {
                "activation_failed": "Unable to activate the registration page. Try again later or contact SpotMe support.",
                "sessions_field": "sessions"
            },
            "reg_url": "Registration page URL",
            "registration_preview": "Registration preview",
            "request_approved": "approved",
            "request_denied": "denied",
            "request_status_change_failed": "Could not update the request status. Try again later. If the problem persists, please contact the support.",
            "request_status_changed_at": "Request {0} on {1}.",
            "request_status_changed_successfully": "The request has been {0} successfully.",
            "title": "Attract new users",
            "url_preview": "Page will be available at: {0}"
        },
        "analytics": {
            "no_pending_users": "No pending registrations",
            "pending_registrations": "Pending registrations",
            "pending_users": "user|users",
            "to_approval_page": "Go to approval page"
        },
        "configuration": {
            "access_code": "Access code",
            "access_code_email_template": "Access code email",
            "access_code_email_template_hint": "Email sent to users that already have an existing account to confirm the access code",
            "access_limitation": "Access limitation",
            "account_updated_email_template": "Profile update confirmation email",
            "account_updated_email_template_hint": "Email sent to attendees after they review their profile information and submit the registration form.",
            "actions": {
                "add_condition": "Add targeting",
                "add_detail_section": "Add section",
                "add_new_exclusion_group": "New exclusion group",
                "add_new_inclusion_group": "New inclusion group",
                "add_section": "Add form",
                "allow_logins": "Show login button",
                "allow_logins_hint": "Event app log in button displayed, if the event is in production.",
                "allow_private_registrations": "Allow invitees to submit and edit their attendance status",
                "allow_private_registrations_hint": "To no longer accept RSVP responses, disable this setting.",
                "allow_profile_updates": "Allow attendees to update their profile information",
                "allow_profile_updates_hint": "E.g. information submitted as part of the registration.",
                "allow_registrations": "Allow attendees to self-register",
                "allow_registrations_hint": "To close the registration, disable this setting.",
                "allow_rsvp_user_limits": "Set attendance capacity",
                "allow_rsvp_user_limits_hint": "As soon as the capacity is reached, registrants will no longer be able to accept your RSVP invitation.",
                "allow_self_user_limits": "Set registration capacity",
                "allow_self_user_limits_hint": "As soon as the capacity is reached, registrants will no longer be able to register on your registration page.",
                "enable_embed": "Make your registration form available on other websites",
                "enable_min_registered_sessions": "Set minimum number of session registrations",
                "enable_min_registered_sessions_hint": "Minimum number of sessions an attendee must register for to successfully register for your event.",
                "enable_self_reg_waiting_list": "Waiting list",
                "registration_status": "Registration status:",
                "remove": "Delete",
                "rename": "Rename",
                "skip_pin": "Skip PIN code for Backstage team members",
                "skip_pin_hint": "Backstage team members will not go through the registration retrieval process, even though they are existing users in the Backstage user list. This enables team members to test the registration experience for both new and existing registrants.",
                "switch_type": "Switch to {0}"
            },
            "add_targeted_email": "+ Send a different email to specific target group",
            "advanced_design": "Advanced design",
            "advanced_design_section": {
                "add_page": "Add page +",
                "delete_page": "Delete page",
                "delete_page_text": "Are you sure you want to delete this page? This action cannot be undone.",
                "edit_page": "Edit page",
                "manage_pages": "Manage pages",
                "mobile_breakpoint": "Mobile breakpoint",
                "new_page": "Add new page",
                "page_title": "Title",
                "pages": "Pages",
                "unsaved_changes": "Unsaved changes",
                "unsaved_changes_text": "You have unsaved changes on this page. Switching pages will discard them. What would you like to do?"
            },
            "authentication": "Authentication",
            "authentication_type": {
                "email": "Email authentication",
                "email_hint": "Participants may register using an email address",
                "email_sso": "Email authentication & Single Sign-On (SSO)",
                "email_sso_hint": "Participants may register using an email address and SSO credentials",
                "sso": "Single Sign-On (SSO)",
                "sso_hint": "Participants may register using SSO credentials",
                "sso_select": "Select available SSOs"
            },
            "capacity_reached_emails_hint_1": "Email notifications to be sent to the specified email addresses {0}",
            "capacity_reached_emails_hint_2": "when the registration capacity is reached.",
            "confirmation_email_template": "Registration pending email",
            "confirmation_email_template_hint": "Email sent to user registering while manual approval is enabled. Once approved, users will automatically receive Login email.",
            "copy_link": "Copy link",
            "custom_fonts": "Custom fonts",
            "custom_fonts_section": {
                "headers": {
                    "file_name": "File name",
                    "preview": "Preview",
                    "uploaded_at": "Uploaded at"
                },
                "messages": {
                    "confirm_delete": "Are you sure you want to delete {0}?",
                    "confirm_delete_multiple": "Are you sure you want to delete the selected font?|Are you sure you want to delete the selected {0} fonts?",
                    "delete_failed": "Could not delete the font. Please try again.",
                    "delete_success": "Font has been deleted.",
                    "delete_success_multiple": "Font has been deleted.|{0} fonts have been deleted.",
                    "upload_failed": "Some fonts could not be uploaded. Please try again.",
                    "upload_success": "{0} of {1} item uploaded|{0} of {1} items uploaded"
                },
                "upload_font": "Upload font"
            },
            "default_email": "Default Email",
            "default_locale": "Default",
            "design": "Design",
            "design_section": {
                "advanced_reg_banner": "These settings apply to the registration form and the pre-registration confirmation overlay.",
                "banner": {
                    "hint": "File types: PNG, JPEG. Max file size 10MB. Recommended resolution 2880x692.",
                    "label": "Banner"
                },
                "footer": {
                    "label": "Footer",
                    "opt_label": "Show footer",
                    "text_placeholder": "© YEAR - Name of the company",
                    "tip": "Footer will be visible just in the landing page. 160 characters max. length."
                },
                "heading": "Customize your registration page",
                "logo": {
                    "hint": "File types: PNG, JPEG. Max file size 1MB. Recommended resolution 512x512 px.",
                    "label": "Logo"
                },
                "ogimage": {
                    "hint": "File types: PNG, JPEG. Recommended resolution 1200x630.",
                    "label": "OG Image"
                },
                "preview": {
                    "form": "Form",
                    "landing_page": "Landing page"
                },
                "primary_color": "Primary color",
                "register": "Register",
                "show_calendar": {
                    "hint": "Control the visibility of calendar button during registration",
                    "label": "Show Add to calendar buttons",
                    "top_label": "Add to calendar buttons"
                },
                "show_date": {
                    "hint": "Control the visibility of the event dates during registration",
                    "label": "Show dates",
                    "top_label": "Event dates"
                },
                "text_color": "Primary button text color"
            },
            "disable_manual_approval": "Disable manual approval to use this option.",
            "disable_modal": {
                "action": "Disable",
                "text_1": "Be aware that nobody will be able to register for the event through the registration link.",
                "text_2": "Are you sure you want to disable the registration page?",
                "title": "Disable the registration page"
            },
            "email_domains": "Allowed email domains",
            "email_domains_description": "Limit email domains with which attendees can register.",
            "email_target_group": "Email - target group {0}",
            "emails": "Emails",
            "emails_intro": "Customize which emails are sent automatically by SpotMe to attendees when they are registering or accessing the app. You can modify the built-in templates or choose your own below.",
            "embed": "Embedding",
            "embed_alert": "In order to embed this code on your site, we need to enable the domain. Please reach out to our support team to assist you with this. If the domain is not enabled, the embedding code will not work.",
            "embed_choice": "Please use the code snippet relevant to your event.",
            "embed_code": "Without UTM parameters",
            "embed_code_copy": "Copy code",
            "embed_code_with_utm": "With UTM parameters",
            "embed_info": "Design options applied in the Design section will be reflected in the embedded form.",
            "embed_label": "Embed code",
            "embed_utm_info": "A UTM (Urchin Tracking Module) is a set of tags added to a URL that help identify where users come from, allowing to track the source of submissions. ",
            "embed_utm_link": "More on UTM",
            "event_details": "Page builder",
            "exclusion_groups_intro": "Creating mutually exclusive session groups. Registering for one session in the group will prevent attendees from registering for another sessions within the same group.",
            "form": {
                "add_description": "Add description",
                "add_session_registration": "Add session registration",
                "basic_info": "Basic info",
                "block_list": "All domains except banned ones",
                "capacity_reached_emails": "Registration capacity",
                "description": "Description",
                "domains_listing": "Specify the domains",
                "edit_description": "Edit description",
                "edit_session_registration": "Edit session registration",
                "email_domains": {
                    "any": "Any email domain",
                    "label": "Allow users to register with"
                },
                "email_domains_block_free": "Block free email providers",
                "email_domains_block_placeholder": "competitor1.com, competitor2.com...",
                "email_domains_pass_placeholder": "mycompany.com",
                "less_settings": "Less settings",
                "locale_tooltip": "Registration page sections and content are always the same for all languages. If you update or delete one (e.g., by adding a description or deleting a session), it will affect the registration page in all languages.",
                "manage_languages_settings": "You can manage your default language or add additional languages in your {0}.",
                "manage_languages_settings_link": "settings",
                "missing_compatible_fields": "You can only use targeting on fields that are dropdown, single or multiple choice, or checkboxes in the main form",
                "more_settings": "More settings",
                "no_sections": "As the details page does not have any sections; the registration box will be placed in the middle of the screen.",
                "notification_emails_placeholder": "name.surname@domain.com",
                "notifications_emails": "Summary",
                "page_builder_empty_warning": "Before adding any content to your registration page, make sure to set up the relevant workspace and registration languages first.",
                "pass_list": "Only allowed email domains",
                "placeholders": {
                    "presenter": "Choose speakers",
                    "session": "Choose sessions",
                    "sponsor": "Choose sponsors"
                },
                "registration_url_alert": "If you change this link, the old one won't work anymore.",
                "registration_url_label": "Registration page URL",
                "section_types": {
                    "editorial": "Text",
                    "presenter": "Speakers",
                    "session": "Sessions",
                    "sponsor": "Sponsors"
                },
                "sections": {
                    "builder": "Registration page builder",
                    "collapse_items": "Collapsible items",
                    "collapse_items_hint": "Decide how many items to display on the page before the \"Show more\" button.",
                    "show_in_nav": "Show this section title in registration page navigation bar",
                    "show_in_nav_hint": "You can have a maximum of 4 sections displayed in the navigation bar"
                },
                "session_registration": "Session registration",
                "vivenu_event_id": "Enter your vivenu event ID"
            },
            "form_design": "Form design",
            "form_fields": "Form fields",
            "free_domains_list": "Blocks domains such as gmail.com or yahoo.com. {0)",
            "free_domains_list_link_label": "See list",
            "gtm_container_id": "Google Tag Manager container ID",
            "gtm_container_id_hint": "Add your Google Tag Manager container (e.g. GTM-XXXXXXX) to manage analytics and conversion tracking for this registration page. This allows you to track signups from ads (e.g. Google, LinkedIn) and other marketing tools without changing application code.",
            "hint_manage_pending": "You can manage registration requests from {0}.",
            "hint_manage_waiting_list": "You can manage the waiting list from the {0} tab.",
            "inclusion_groups_intro": "Creating mutually inclusive session groups. Registering for one session in the group will automatically register for all the other sessions within the same group.",
            "integration": "Integration",
            "integration_description": "When people register, use an advanced search to complete their profiles with information from an integrated external source.",
            "integration_hidden_to_desc": "Lookup will be not trigger to attendees who match the below rule(s).",
            "integration_hidden_to_label": "Dont trigger lookup to",
            "integration_label": "Profile enrichment",
            "integration_match_fields": "Information displayed on the registration page to let users select a match",
            "integration_match_fields_hint": "If multiple possible profile matches are found, this information will be displayed so the user can review the options and choose the correct profile.\nWhen setting up the registration form in Backstage, a new form is automatically added at the end of the registration process where you can edit the text to be displayed to users.",
            "integration_name": "Integration name",
            "integration_populate_fields": "User fields populated from the external source",
            "integration_populate_fields_hint": "These fields in the Backstage user profile will be filled with data returned by the integration API.",
            "integration_search_fields_hint": "Select the fields that will be used to locate registrant profiles on the external system of record. NOTE: Complete the field mapping above, before selecting the search fields.",
            "integration_secret_key": "Secret key",
            "integration_select_field_placeholder": "Select field",
            "integration_select_fields_placeholder": "Select fields",
            "integration_targeting_label": "Targeting",
            "integration_trigger_fields": "Backstage user fields that, when empty, trigger the profile lookup",
            "integration_trigger_fields_hint": "If at least one of these fields is empty, the lookup will be triggered. Some users e.g. RSVP invitees or users updating a previously registered profile, will not need to go through the lookup.",
            "integration_url": "Integration url",
            "learn_more": "Learn more",
            "link_preview": "Link preview",
            "link_preview_description": "Control how the registration landing page appears in link previews when the page is shared on social platforms and chat apps.",
            "link_preview_description_label": "Description",
            "link_preview_title_label": "Title",
            "linkedin_partner_id": "LinkedIn Partner ID",
            "linkedin_partner_id_hint": "Add your LinkedIn Partner ID (typically a 6-8 digit numeric code) to enable LinkedIn Insight Tag tracking for this registration page. Use this if you are not managing LinkedIn tracking through Google Tag Manager.",
            "locale": "Locale",
            "login_email_template": "Login email",
            "login_email_template_hint": "Email sent to users logging in, or when their registration request is approved.",
            "manage_pending_link_label": "Users > Pending registrations",
            "manual_approval": "Manual approval",
            "manual_approval_description": "Control who can access your event by adding a manual review step to your registration process.",
            "manual_approval_label": "Manually approve registrations",
            "messages": {
                "event_section_removal": "Are you sure you want to delete this section?",
                "image_does_not_fit": "Could not save. Please crop the image",
                "modify_success": "Configuration modified",
                "save_failed": "Could not save the configuration. Try again later or contact the support.",
                "save_success": "Configuration saved"
            },
            "need_help": "Need help?",
            "new_event_section_placeholder": "Type a title for this section",
            "new_section_placeholder": "Type a name for the form",
            "new_sessions_group_placeholder": "Type a title for this group",
            "no_exclusion_groups": "There are no exclusion groups",
            "no_i18n": {
                "warning_wall_buttons_hint": "The primary button, labeled '{0}', directs attendees to the registration page, while the secondary button, labeled '{1}', can be customized to link to a different destination specified below.",
                "warning_wall_buttons_hint_accept": "Confirm",
                "warning_wall_buttons_hint_reject": "Decline"
            },
            "no_inclusion_groups": "There are no inclusion groups",
            "no_title_set": "- No title set -",
            "notification_emails": "Registration notifications",
            "notifications_1": "Email notifications to be sent to the specified email addresses {0}. The email contains a summary of all new registrations, registration updates and profile updates.",
            "notifications_2": "once per day at 08:00 in the configured timezone",
            "preview_page": "Open page",
            "reg_types": {
                "hybrid": {
                    "desc": "Combine open registration and personal invitations.",
                    "title": "Public & Private"
                },
                "private": {
                    "desc": "Invite specific people and ask them to confirm their attendance.",
                    "title": "Private - RSVP"
                },
                "public": {
                    "desc": "Anyone with the registration link may register.",
                    "short_title": "Public",
                    "title": "Public - Open registration"
                }
            },
            "registration_confirmation_email_template": "Open registration confirmation email",
            "registration_confirmation_email_template_hint": "Email sent to attendees to confirm that their registration was successfully submitted.",
            "remove_sessions_reg_to_enable": "Remove session registration items from the form to enable this option.",
            "rsvp_accepted_email_template": "RSVP invitation accepted",
            "rsvp_accepted_email_template_hint": "Email sent to attendees when they answer \"Yes\" to an event invitation.",
            "rsvp_declined_email_template": "RSVP invitation declined",
            "rsvp_declined_email_template_hint": "Email sent to attendees when they answer \"No\" to this event invitation.",
            "section_has_anchor": "Visible in nav bar",
            "session_groups_count": "{0} session|{0} sessions",
            "session_registration": "Session registration",
            "settings": "Settings",
            "social_media_integration": "Marketing & Conversion tracking",
            "switch_type": {
                "message": "You can change the registration type for your event at any time. Settings may change from one registration type to another, so please check the settings if you change the registration type.",
                "title": "Switch to {0} registration"
            },
            "title": "Registration",
            "unknown_account_email_template": "Unknown account email",
            "unknown_account_email_template_hint": "Email sent to users trying to log in without registering first.",
            "waiting_list_email_template": "Waiting list email",
            "waiting_list_email_template_hint": "Email sent to users who register after the registration capacity is reached, and they're added to the waiting list. If approved, users will automatically receive Login email.",
            "warning_wall": "Pre-registration confirmation",
            "warning_wall_buttons": "Buttons",
            "warning_wall_buttons_hint": "The labels for the primary and secondary buttons can be edited in the translations manager under the section '{0}'; the keys are '{1}' and '{2}'. The primary button directs attendees to the registration page, while the secondary button's destination site can be customized below.",
            "warning_wall_buttons_hint_accept": "warning_wall_accept",
            "warning_wall_buttons_hint_reject": "warning_wall_reject",
            "warning_wall_buttons_hint_section": "Registration / Actions",
            "warning_wall_description": "A confirmation screen will appear to registrants before they will be able to continue to the registration page. Here you can, for example, ask them to confirm their profession or acknowledge key information.",
            "warning_wall_enabled": "Show pre-registration confirmation",
            "warning_wall_redirect": "Secondary button URL*",
            "warning_wall_redirect_hint": "The URL must start with 'https://'",
            "warning_wall_redirect_placeholder": "https://...",
            "warning_wall_text": "Text*"
        },
        "sessions_configuration": {
            "available_seat_email": "Available seat email",
            "available_seat_email_hint": "This email is sent to the first user on the waitlist when a seat becomes available.",
            "lease_time": "If an available seat is not claimed, inform the next eligible user in",
            "session_exclusions": "Mutually exclusive sessions",
            "session_import": "Import / export",
            "session_import_page": {
                "export_action": "Export XLS",
                "export_modal": {
                    "title": "Exporting session registrations"
                },
                "export_subtitle": "Export an Excel of the current session registrations records.",
                "export_title": "Export XLS",
                "import_failed": "Session registrations failed to import",
                "import_started": "Import started...",
                "import_subtitle": "Use an Excel file in order to import session registrations or edit existing registrations. The import will ignore any existing session registration or capacity settings that are enabled, including exclusion or inclusion groups.",
                "import_succeeded": "Session registrations successfully imported",
                "import_title": "Import XLS"
            },
            "session_inclusions": "Mutually inclusive sessions",
            "session_reg_settings": "Settings",
            "unclaimed_seat_email": "Seat was not claimed email",
            "unclaimed_seat_email_hint": "This email is sent to the user if they fail to register within the specified time window.",
            "waitlist": "Waitlist",
            "waitlist_intro": "Enable the waitlist feature on individual session pages. When a seat becomes available, the first eligible user will automatically receive an email notification about the newly opened seat."
        },
        "template_picker": {
            "preview": "Preview",
            "start_building": "Start building",
            "subtitle": "Pick the starting point for your site builder. Note that you cannot change your mind once you start building.",
            "templates": {
                "blank_subtitle": "Start with a clean slate and build your page entirely from scratch.",
                "blank_title": "Blank",
                "multipage_subtitle": "A structured layout with separate pages for different sections of your content.",
                "multipage_title": "Multi-page template",
                "singlepage_subtitle": "A simple layout with all your content flowing on one page.",
                "singlepage_title": "Single-page template",
                "template_subtitle": "Begin with the registration design and layout already set up in your workspace template.",
                "template_title": "Your workspace template"
            },
            "title": "Choose how to start"
        }
    }
}
